import React from 'react';

import { EMPLOYERS_UPLOAD_BY_PEO_TEMPLATE } from 'src/assets/employer';
import { BulkUploadForm } from 'src/components/bulkUpload';
import { EMPLOYERS_UPLOAD_BY_PEO_TEMPLATE_NAME } from 'src/constants/templates';

import { templateSchema } from '../constants';
import { InvitedEmployerData } from '../types';
import { convertDataWithSchema } from '../utils/convertDataWithSchema';

type EmployersUploadFormProps = {
  handleEmployersData: (employers: InvitedEmployerData[]) => Promise<void> | void;
  handleCancel: () => void;
  switchClosability: (isClosureAllowed: boolean) => void;
  nextStepLoading?: boolean;
  uploadFormTopNotice: string;
};

export const EmployersUploadForm: React.FC<EmployersUploadFormProps> = ({
  handleEmployersData,
  handleCancel,
  switchClosability,
  nextStepLoading,
  uploadFormTopNotice,
}) => {
  return (
    <BulkUploadForm
      convertDataWithSchema={convertDataWithSchema}
      templateSchema={templateSchema}
      templateDownloadLink={EMPLOYERS_UPLOAD_BY_PEO_TEMPLATE}
      templateDownloadName={EMPLOYERS_UPLOAD_BY_PEO_TEMPLATE_NAME}
      topNotice={uploadFormTopNotice}
      handleEntitiesData={handleEmployersData}
      handleCancel={handleCancel}
      switchClosability={switchClosability}
      nextStepLoading={nextStepLoading}
    />
  );
};
